import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { ChordDiagram } from "./ChordDiagram";
import { getChordFingering } from "../utils/chordDiagrams";

const CHORD_REGEX = /([A-G])(#|b)?([mM]|maj|min|dim|aug|sus\d?|add\d?)?(\d*)(\/[A-G](#|b)?)?(?=[\s/()\n,.-]|$)/g;

interface ChordChartWithHoverProps {
  text: string;
  className?: string;
  chordClassName?: string;
}

export const ChordChartWithHover: React.FC<ChordChartWithHoverProps> = ({
  text,
  className = "",
  chordClassName,
}) => {
  const parts: { type: "chord" | "text"; value: string }[] = [];
  let lastIndex = 0;
  let match;

  const regex = new RegExp(CHORD_REGEX.source, "g");
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: "text", value: text.slice(lastIndex, match.index) });
    }
    parts.push({ type: "chord", value: match[0] });
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push({ type: "text", value: text.slice(lastIndex) });
  }

  return (
    <pre className={`whitespace-pre-wrap font-mono text-sm m-0 ${className}`}>
      {parts.map((part, i) =>
        part.type === "chord" ? (
          <ChordWithTooltip key={`${i}-${part.value}`} chordName={part.value} chordClassName={chordClassName} />
        ) : (
          <React.Fragment key={i}>{part.value}</React.Fragment>
        )
      )}
    </pre>
  );
};

const ChordWithTooltip: React.FC<{ chordName: string; chordClassName?: string }> = ({ chordName, chordClassName }) => {
  const fingering = getChordFingering(chordName);

  const content = fingering ? (
    <div className="p-2">
      <ChordDiagram chordName={chordName} fingering={fingering} size={120} />
    </div>
  ) : (
    <span className="text-sm text-gray-500">{chordName} (no diagram)</span>
  );

  return (
    <Tippy
      content={content}
      placement="top"
      delay={[200, 0]}
      animation="fade"
      duration={150}
      interactive
      appendTo={document.body}
      zIndex={9999}
    >
      <span className={`cursor-help font-semibold underline decoration-dotted ${chordClassName || "text-[#5932EA] decoration-[#5932EA]/50 hover:text-[#4a28c7] hover:decoration-[#4a28c7]"}`}>
        {chordName}
      </span>
    </Tippy>
  );
};
